import React, { useState } from "react";
import { Accordion, Button, Form, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PhoneInput from "react-phone-number-input";
import {
  faTasks,
  faForward,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import "react-phone-number-input/style.css"; // Import styles for phone input
import UtilMethods from "../../util/UtilMethods";
import Address from "../common/Address";
import { sendOTP, verifyOTP } from "../../services/AdminServices";
// Constants for dropdown options
import { PAYMENT_METHODS, STATUS_OPTIONS } from "../common/Constants";
import { useEffect } from "react";

const GroupRegistrationAccordion = ({
  groupInfo,
  editingMemberIndex,
  otpVerified,
  userType,
  handleInputChange,
  handleAddMember,
  eventData,
  handleApprove,
  setGroupInfo,
  setActiveKey,
  setEditingMemberIndex,
  setOTPVerified,
  setOriginalGroupInfo,
}) => {
  const [errors, setErrors] = useState({});
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const isAdmin = userType?.includes("A");
  const [otpLoading, setOTPLoading] = useState(false);
  const [otpSent, setOTPSent] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [otp, setOTP] = useState(groupInfo.otp || "");
  const [resendCoolDown, setResendCoolDown] = useState(0); // CoolDown state for resend OTP

  useEffect(() => {
    // UtilMethods.log('info',"GroupRegistrationAccordion useEffect",userType);
    // UtilMethods.log('info',"GroupRegistrationAccordion OPTVerified", otpVerified);
    setPaymentMethods(
      eventData && eventData.paymentMethods?.length
        ? eventData.paymentMethods.split(", ").map((method) => ({
            key: method,
            value: method,
          }))
        : PAYMENT_METHODS
    );
    let timer;
    if (resendCoolDown > 0) {
      timer = setInterval(() => {
        setResendCoolDown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendCoolDown, eventData?.paymentMethods]);

  // Utility function for field validation
  const validateField = (label, value, type, isRequired) => {
    // Check for required fields
    //console.log("validateField GRp Registration label:", label);
    // console.log("validateField GRp Registration value:", value);
    // Ensure value is a string before calling .trim()
    const valueString = value ? String(value) : "";

    if (isRequired && (!valueString || valueString.trim() === "")) {
      return `${label} is required.`;
    }

    // Validate email
    if (type === "email" && value && !UtilMethods.validateEmail(value)) {
      return "Please enter a valid email address.";
    }

    // Validate phone and emergency contact number
    if (
      (type === "phone" || type === "emergencyContactNumber") &&
      value &&
      !UtilMethods.validatePhone(value)
    ) {
      return `Please enter a valid ${
        type === "phone" ? "phone number. Include country code" : "Emergency Contact number. Include country code"
      }.`;
    }

    // Validate numeric values
    if (type === "number" && value && !/^[0-9]*$/.test(value)) {
      return `${label} must be a numeric value.`;
    }

    return "";
  };

  const validateOTPForm = () => {
    const newErrors = {};
    //console.log("validateOTPForm GRp Registration groupInfo:", groupInfo);
    if (
      !groupInfo.email ||
      process.env.REACT_APP_GUEST_EMAIL === groupInfo.email
    ) {
      newErrors.email = "Valid Email is required.";
    } else if (!UtilMethods.validateEmail(groupInfo.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!groupInfo.phone) {
      newErrors.phone = "Phone is required";
    } else if (!UtilMethods.validatePhone(groupInfo.phone)) {
      newErrors.phone = "Please enter a valid phone number. Include country code.";
    }
    console.log("validateOTPForm GRp Registration errors:", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSendOTP = async (e) => {
    console.log("handleSendOTP GRp Registration");
    e.preventDefault();
    if (!validateOTPForm()) {
      setErrors({
        general: "Please fill valid email/phone before sending OTP.",
      });
    } else if (resendCoolDown === 0 && validateOTPForm()) {
      setOTPLoading(true);
      try {
        //console.log("handleSendOTP formData", formData);
        await sendOTP(
          groupInfo.email,
          groupInfo.phone,
          groupInfo.retreatID,
          "RETREAT"
        );
        setOTPSent(true);
        setResendCoolDown(30); // 30 seconds cooldown
        showAlert(
          "OTP sent to your phone. Please enter the code in OTP field.",
          "warning"
        );
      } catch (error) {
        console.error("\n\n ##### Error sending OTP", error.message);
        console.error("\n\n ##### Error sending OTP", error.responseData);
        setErrors({ general: error.message });
        {
          /*if (error.responseData) {
          console.log("Data available populating data ", error.responseData);
          let groupData = error.responseData;
          setGroupInfo(groupData);
          setOTPLoading(false);
          setOTPVerified(true);
          //setErrors({ general: "OTP sent to your phone. Please enter the code in OTP field." });
        }*/
        }
      } finally {
        setOTPLoading(false);
      }
    } else {
      setErrors({ general: "Please wait before resending OTP." });
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    //setLoading(true);

    if (!otpVerified) {
      if (!otp) {
        setErrors({ general: "Please enter the OTP." });
        return;
      }
      try {
        const response = await verifyOTP(
          otp,
          groupInfo.email,
          groupInfo.phone,
          "RETREAT",
          groupInfo.retreatID
        );
        console.log("verifyOTP response", response);
        console.log("verifyOTP response  response.status", response.status);
        console.log("verifyOTP response", response);
        const isVerified =
          response.data.status === "approved" ? true : response.data.status;
        console.log("verifyOTP isVerified", isVerified);
        console.log("verifyOTP response.data.message", response?.data?.message);

        if (isVerified) {
          setOTPVerified(true);
          console.log(
            "verifyOTP response.data.data.groupData",
            response.data?.data?.groupData
          );
          //setErrors({ general: "OTP verified successfully." });
          if (response.status === 202 && response.data?.data?.groupData) {
            // registration available populating data
            const groupData = response.data?.data?.groupData;
            showAlert(
              "OTP verified successfully. Registration exists with email" +
                groupData.email,
              "warning"
            );
            {
              /*setErrors({
              general:
                "OTP verified successfully. Registration exists with email" +
                groupData.email,
            });*/
            }
            setGroupInfo(groupData);
            setOriginalGroupInfo({ ...groupData });
          } else if (
            response.status === 203 &&
            response.data?.data?.groupData
          ) {
            // registration available populating data
            console.log(
              "verifyOTP response.data.groupData",
              response.data?.data?.groupData
            );
            //const groupData = response.data?.data?.groupData;

            setOTPVerified(false);
            setOTPSent(false);
            setOTPLoading(false);
            
            setOTP("");
            setResendCoolDown(0); // Reset cooldown
            setErrors({
              general:
                response?.data?.message +
                " Please try again with correct Phone/Email.",
            });
            //setGroupInfo(groupData);
          } else {
            //setErrors({ general: "OTP verified successfully." });
            showAlert("OTP verified successfully.", "success");
          }
        } else {
          setErrors({ general: "Invalid OTP. Please try again." });

          return;
        }
      } catch (error) {
        setErrors({ general: "Error verifying OTP. Please try again." });

        return;
      }
    } else {
      //setErrors("OTP verified successfully.", "success");
      showAlert("OTP verified successfully.", "success");
    }
  };

  const validateForm = () => {
    let newErrors = {};
    console.log("validateForm Group Registration newErrors:", newErrors);

    // Validation rules based on the field
    const validationRules = {
      email: { label: "Email", type: "email", isRequired: true },
      phone: { label: "Phone", type: "phone", isRequired: true },
      firstName: { label: "First Name", type: "text", isRequired: true },
      lastName: { label: "Last Name", type: "text", isRequired: true },
      address: { label: "Street Address", type: "text", isRequired: true },
      country: { label: "Country", type: "text", isRequired: false },
      city: { label: "City", type: "text", isRequired: true },
      state: { label: "State", type: "text", isRequired: true },
      zipCode: { label: "Zip Code", type: "text", isRequired: true },
      emergencyContactNumber: {
        label: "Emergency Contact Number",
        type: "text",
        isRequired: true,
      },
      emergencyContactPersonName: {
        label: "Emergency Contact Name",
        type: "text",
        isRequired: true,
      },
      paymentMethod: {
        label: "Payment Method",
        type: "text",
        isRequired: false,
      },
      rooms: {
        label: "Rooms",
        type: "number",
        isRequired: eventData?.type === "Residential",
      },
      numberOfParticipants: {
        label: "Number of Participants",
        type: "number",
        isRequired: true,
      },
    };

    // Iterate over groupInfo and apply validation

    Object.entries(groupInfo).forEach(([field, value]) => {
      if (validationRules[field]) {
        const { label, type, isRequired } = validationRules[field];
        const errorMessage = validateField(label, value, type, isRequired);

        if (errorMessage) {
          newErrors[field] = errorMessage;
        }
      }
    });

    // Check if OTP is verified for guest users
    if (userType === "G" && !otpVerified) {
      newErrors.otp = "OTP verification is required.";
    }
    if (
      userType === "G" &&
      process.env.REACT_APP_GUEST_EMAIL === groupInfo.email
    ) {
      newErrors.email = "Valid Email is required.";
    }
    console.log("validateForm Group Registration newErrors:", newErrors);
    setErrors(newErrors);

    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };
  const showAlert = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setTimeout(() => {
      setAlertMessage("");
      setAlertType("");
    }, 5000);
  };
  const handleSubmit = (e) => {
    console.log("handleSubmit GRp Registration");
    e.preventDefault();
    if (validateForm()) {
      console.log("NEXT Validation passed.");
      //handleAddMember();
      console.log("handleSubmit Setting active key as 2 : Group Members section");
      setActiveKey("2"); // Open the "Group Members" accordion (index-based)
      setEditingMemberIndex(0);
    } else {
      console.log("NEXT Validation failed.");
    }
  };

  // Utility function to render form fields
  const renderTextField = (
    label,
    field,
    isRequired = true,
    type = "text",
    readOnly = false,
    placeholder
  ) => {
    const error = errors[field];
    const handleChange = (e) => {
      let value = e.target.value;
      if (type === "number" && value === "") {
        value = "0";
      }
      handleInputChange(field, value);
      const validationError = validateField(label, value, type, isRequired);
      setErrors((prev) => ({ ...prev, [field]: validationError }));
    };

    return (
      <Form.Group>
        <Form.Label>
          {label} {isRequired && <span style={{ color: "red" }}>*</span>}
        </Form.Label>
        {type === "phone" || type === "emergencyContactNumber" ? (
          <>
            <div
              style={{
                border: "1px solid #dad5ce",
                borderRadius: "10px",
              }}
            >
              <PhoneInput
                defaultCountry="US"
                international
                flagUrl="https://flagcdn.com/w320/{xx}.png"
                placeholder={placeholder || label}
                value={
                  type === "number"
                    ? groupInfo[field] || groupInfo[field] === 0
                      ? groupInfo[field]
                      : ""
                    : groupInfo[field] || ""
                }
                onChange={(value) => {
                  handleInputChange(field, value);
                  const validationError = validateField(
                    label,
                    value,
                    type,
                    isRequired
                  );
                  setErrors((prev) => ({ ...prev, [field]: validationError }));
                }}
                className={`form-select ${error ? "is-invalid" : ""}`}
                readOnly={readOnly}
                required={isRequired}
              />
            </div>
            {error && <div className="invalid-feedback d-block">{error}</div>}
          </>
        ) : (
          <>
            <Form.Control
              type={type === "number" ? "number" : type}
              inputMode={type === "number" ? "number" : undefined}
              pattern={type === "number" ? "\\d*" : undefined}
              value={
                type === "number"
                  ? groupInfo[field] !== undefined
                    ? groupInfo[field]
                    : ""
                  : groupInfo[field] !== undefined
                  ? groupInfo[field]
                  : ""
              }
              onChange={handleChange}
              isInvalid={!!error}
              readOnly={readOnly}
              required={isRequired}
              placeholder={placeholder || label}
            />
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          </>
        )}
      </Form.Group>
    );
  };

  return (
    <Accordion.Item eventKey="1">
      <Accordion.Header>
        <h4>
          <FontAwesomeIcon icon={faTasks} /> Registration | ID :{" "}
          {groupInfo?.registrationID || "NEW"}{" "}
          <span style={{ fontWeight: "bold" }}>
            | Status:{" "}
            <span
              style={{
                color: groupInfo?.status === "Wait List" ? "orange" : "inherit",
                textTransform:
                  groupInfo?.status === "Wait List" ? "uppercase" : "none",
              }}
            >
              {groupInfo?.status || "Not Available"}
            </span>{" "}
            | Count : {groupInfo?.numberOfParticipants || 0}{" "}
          </span>
        </h4>
      </Accordion.Header>
      <Accordion.Body>
        <p style={{ textAlign: "center" }}>
          <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
            {eventData?.wog ||
              "Luke 21: 34-35 34 “Beware that your hearts do not become drowsy from carousing and drunkenness and the anxieties of daily life, and that day catch you by surprise 35 like a trap. For that day will assault everyone who lives on the face of the earth. 36 Be vigilant at all times and pray that you have the strength to escape the tribulations that are imminent and to stand before the Son of Man.”"}{" "}
          </span>
        </p>

        <Form>
          {errors.general && (
            <div className="alert alert-danger" role="alert">
              {UtilMethods.formatTextWithLineBreaks(errors.general)}
            </div>
          )}
          {alertMessage && (
            <div className={`alert alert-${alertType}`} role="alert">
              {alertMessage}
            </div>
          )}
          <Row className="mb-1">
            {/* Phone & Email */}
            <Col md={6}>
              {renderTextField(
                "Email",
                "email",
                true,
                "email",
                userType === "U" || (userType === "G" && otpVerified)
              )}
            </Col>
            <Col md={6}>
              {renderTextField(
                "Phone",
                "phone",
                true,
                "phone",
                userType === "U" || (userType === "G" && otpVerified)
              )}
            </Col>
            {userType === "G" && !otpVerified && (
              <>
                {/* OTP Input Field - Display only if OTP has been sent */}
                {otpSent && (
                  <div className="form-group mb-1 mt-1">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="OTP"
                      name="otp"
                      value={otp}
                      onChange={(e) => setOTP(e.target.value)}
                      required
                    />
                    {errors.otp && (
                      <span className="text-danger">{errors.otp}</span>
                    )}
                  </div>
                )}
                <div className="d-flex justify-content-between gap-4 mb-1 mt-1">
                  <button
                    type="button"
                    className="btn btn-light flex-grow-1 mt-1"
                    onClick={handleVerifyOTP}
                    disabled={otpVerified || !otpSent}
                  >
                    {otpVerified ? "Verified" : "Verify OTP"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary flex-grow-1 mt-1"
                    onClick={handleSendOTP}
                    disabled={otpLoading || resendCoolDown > 0}
                  >
                    {otpLoading ? "Sending OTP..." : "Send OTP"}
                    {resendCoolDown > 0 && ` (${resendCoolDown}s)`}
                  </button>
                </div>
                <div className="badge-warning">
                  {" "}
                  OTP not verified! Please verify the OTP to continue.
                </div>
              </>
            )}
          </Row>

          {((userType === "G" && otpVerified) || userType !== "G") && (
            <>
              <Row className="mb-1">
                <Col>
                  {renderTextField(
                    "First Name",
                    "firstName",
                    true,
                    "text",
                    userType === "G" && !otpVerified
                  )}
                </Col>
                <Col>
                  {renderTextField(
                    "Last Name",
                    "lastName",
                    true,
                    "text",
                    userType === "G" && !otpVerified
                  )}
                </Col>
              </Row>
              <Row className="mb-1">
                <Form.Group>
                  <Address
                    formData={groupInfo}
                    setFormData={setGroupInfo}
                    displayMode="label"
                    enabled={!(userType === "G" && !otpVerified)}
                    colCount={2}
                    errors={errors}
                  />
                </Form.Group>
              </Row>
              {/* Emergency Contact Name */}
              <Row className="mb-1">
                <Col>
                  {renderTextField(
                    "Emergency Contact Name",
                    "emergencyContactPersonName",
                    true,
                    "text",
                    userType === "G" && !otpVerified
                  )}
                </Col>

                {/* Emergency Contact Number */}

                <Col>
                  {renderTextField(
                    "Emergency Contact Number",
                    "emergencyContactNumber",
                    true,
                    "emergencyContactNumber",
                    userType === "G" && !otpVerified
                  )}
                </Col>
              </Row>
              {/* Special Request */}
              <Row className="mb-1">
                <Col>
                  <Form.Group>
                    <Form.Label>Special Request</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      readOnly={userType === "G" && !otpVerified} // Set readOnly to true for non-admins
                      value={groupInfo.specialRequest || ""}
                      onChange={(e) =>
                        handleInputChange("specialRequest", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Residential Event Fields (Rooms and Share Room) */}
              {eventData?.type === "Residential" && (
                <Row className="mb-1">
                  <Col md={6}>
                    {renderTextField("Rooms", "rooms", true, "number")}
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mt-4">
                      <Form.Check
                        type="checkbox"
                        label="Share Room"
                        checked={groupInfo.shareRoom || false}
                        onChange={(e) =>
                          handleInputChange("shareRoom", e.target.checked)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              {/* Payment Info Fields 
              <Row className="mb-1">
                <Col>
                  <Form.Group>
                    <Form.Label>
                      Payment Method <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Select
                      value={groupInfo.paymentMethod || ""}
                      required
                      disabled={userType === "G" && !otpVerified}
                      isInvalid={!!errors.paymentMethod}
                      onChange={(e) =>
                        handleInputChange("paymentMethod", e.target.value)
                      }
                    >
                      <option key="" value="">
                        Select a payment method
                      </option>
                      {paymentMethods.map((method) => (
                        <option key={method.key} value={method.key}>
                          {method.value}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.paymentMethod}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  {renderTextField("Amount $", "amount", true, "number", true)}
                </Col>
                <Col>
                  <span
                    data-toggle="tooltip"
                    title="Payment received in the bank will be updated within 2 days"
                    style={{ cursor: "pointer" }}
                  >
                    {renderTextField(
                      "Paid Amount $",
                      "paidAmount",
                      false,
                      "number",
                      !isAdmin
                    )}
                  </span>
                </Col>
              </Row> */}
            </>
          )}
          {/* Admin Fields 
          {isAdmin && (
            <>
              <Row className="mb-1">
                <Col md={6}>
                  {renderTextField(
                    "Payment Info",
                    "paymentInfo",
                    true,
                    "text",
                    false,
                    "Payment Info"
                  )}
                </Col>
                <Col md={6}>
                  {renderTextField(
                    "Refund Amount $",
                    "refundAmount",
                    false,
                    "number",
                    false,
                    "Refund Amount"
                  )}
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      value={groupInfo.status || ""}
                      onChange={(e) =>
                        handleInputChange("status", e.target.value)
                      }
                    >
                      {STATUS_OPTIONS.map((status) => (
                        <option key={status.key} value={status.key}>
                          {status.value}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </>
          )} */}
          <Row className="mb-1">
            <Col className="d-flex justify-content-end">
              <Button variant="primary" type="submit" onClick={handleSubmit}>
                {"Next"}
                <FontAwesomeIcon icon={faForward} />
              </Button>
            </Col>
          </Row>
        </Form>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default GroupRegistrationAccordion;
